import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async getTypes(_, filters) {
      return window.$axios.get('company-type', {
        params: filters,
      });
    },
    async getCompany() {
      return window.$axios.get('company?include=companyType,users');
    },
    async getNations() {
      return window.$axios.get('company-nations');
    },
    async getStates() {
      return window.$axios.get('state');
    },
    async informHubspot(_, { name, surname, email }) {
      return window.$axios.post(
        'https://api.hubapi.com/contacts/v1/contact/createOrUpdate/email/' +
          email +
          '/?hapikey=a0fefc71-e158-4fbb-a094-c57d612fe9ff',
        {
          properties: [
            {
              property: 'firstname',
              value: name,
            },
            {
              property: 'lastname',
              value: surname,
            },
            {
              property: 'lifecyclestage',
              value: 'customer',
            },
          ],
        }
      );
    },
  },
});
